import { useContext, useMemo } from 'react';
import I18n from 'I18n';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import UISelect from 'UIComponents/input/UISelect';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { useOnChangeHandlers } from '../../hooks/useOnChangeHandlers';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterGroupLogicGroupToggle = ({
  logicGroupIndex
}) => {
  const {
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    handleOnChange
  } = useOnChangeHandlers();
  const options = useMemo(() => [{
    value: LogicGroupNames.OR,
    text: I18n.text(`newCustomerDataFilters.filterGroupLogicGroupSelection.SelectorOr`)
  }, {
    value: LogicGroupNames.AND,
    text: I18n.text(`newCustomerDataFilters.filterGroupLogicGroupSelection.SelectorAnd`)
  }], []);
  const getLogicGroup = () => {
    var _internalDraftValue$c;
    return internalDraftValue === null || internalDraftValue === void 0 || (_internalDraftValue$c = internalDraftValue.conditions.get(String(logicGroupIndex))) === null || _internalDraftValue$c === void 0 ? void 0 : _internalDraftValue$c.logicGroupName;
  };
  const handleLogicGroupChange = e => {
    const newLogicGroupName = e.target.value;
    if (internalDraftValue) {
      const newInternalDraftValue = internalDraftValue.setIn(['conditions', String(logicGroupIndex)], internalDraftValue.conditions.get(String(logicGroupIndex)).set('logicGroupName', newLogicGroupName));
      dispatch({
        type: 'internalDraftValue',
        payload: newInternalDraftValue
      });
      handleOnChange(newInternalDraftValue);
    }
  };
  const selector = /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "fr-filter-group-logic-group-toggle",
    value: getLogicGroup(),
    onChange: handleLogicGroupChange,
    options: options,
    buttonUse: "transparent"
  });
  return /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "newCustomerDataFilters.filterGroupLogicGroupSelection.Selector",
      options: {
        selector
      }
    })
  });
};
export default FilterGroupLogicGroupToggle;